import React, { useContext, useState, useEffect } from 'react';
import ReactSVG from 'react-svg';
import times from 'times.svg';
import search from 'search.svg';
import FilterToggle from '../Map/FilterToggle';
import { EventMapContext } from '../../context/EventMapContext';

export default function EventFilterDropdown({ areas }) {
  const { setCurrentMenu, variables, setVariables } = useContext(
    EventMapContext
  );

  const [localAreas, setLocalAreas] = useState([]);
  const [localSearch, setLocalSearch] = useState('');

  useEffect(() => {
    setLocalAreas(variables.area_in);
    setLocalSearch(variables.title_cont);
  }, [variables.is_favorited, variables.area_in, variables.title_cont]);

  return (
    <div className="filters-dropdown_ dropdown-sorting-container">
      <header className="dropdown-mobile-header categories">
        <section>
          <ReactSVG
            src={times}
            onClick={e => {
              e.stopPropagation();
              setLocalAreas(variables.area_in);
              setLocalSearch(variables.title_cont);
              setCurrentMenu(null);
            }}
          />
          <button
            aria-label="Clear Filters"
            name="Clear Filters"
            type="button"
            className="underline clear-btn"
            onClick={e => {
              e.stopPropagation();
              setLocalAreas([]);
              setLocalSearch('');
            }}
          >
            Clear
          </button>
        </section>
      </header>

      <div className="filter-dropdown-section">
        <h2 className="dropdown-section-title" style={{ marginBottom: '20px' }}>
          Areas
        </h2>
        <section
          className="dropdown-sorting-inputs"
          style={{ overflowX: 'auto' }}
        >
          {areas.map(area => (
            <label key={area.id} htmlFor={`area-type-${area.id}`}>
              <input
                aria-label={`${area.name}`}
                id={`area-type-${area.id}`}
                type="checkbox"
                checked={localAreas.includes(area.slug)}
                onChange={() => {
                  if (localAreas.includes(area.slug)) {
                    setLocalAreas(
                      localAreas.filter(localArea => localArea !== area.slug)
                    );
                  } else {
                    setLocalAreas([...localAreas, area.slug]);
                  }
                }}
              />
              <p>{area.name}</p>
            </label>
          ))}
        </section>
      </div>
      <section>
        <h2 className="dropdown-section-title">Search Events by Title</h2>
        <div className="mobile-events-search">
          <ReactSVG src={search} />
          <input
            aria-label="Search Events"
            value={localSearch}
            placeholder="Search Events"
            onChange={e => {
              setLocalSearch(e.target.value);
            }}
          />
        </div>
      </section>

      <section style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <button
          aria-label="Apply Filters"
          name="Apply Filters"
          type="button"
          className="btn btn--dark btn--small apply"
          onClick={e => {
            e.stopPropagation();
            setVariables({
              ...variables,
              area: localAreas,
              title_cont: localSearch,
            });
            setCurrentMenu(null);
          }}
        >
          Apply
        </button>
      </section>
    </div>
  );
}
